{
  "title": "items",
  "type": "array",
  "uniqueItems": true,
  "items" : {
    "title": "item",
    "type": "object",
    "properties": {
      "id": {
        "description": "The unique identifier for an item",
        "type": "integer",
        "minimum": 0
      },
      "displayName": {
        "description": "The display name of an item",
        "type": "string"
      },
      "stackSize": {
        "description": "Stack size for an item",
        "type": "integer",
        "minimum": 0
      },
      "enchantCategories" : {
        "description": "describes categories of enchants this item can use",
        "type": "array",
        "uniqueItems": true,
        "items": {
          "type": "string"
        }
      },
      "repairWith" : {
        "description": "describes what items this item can be fixed with in an anvil",
        "type": "array",
        "uniqueItems": true,
        "items": {
          "type": "string"
        }
      },
      "maxDurability": {
        "description": "the amount of durability an item has before being damaged/used",
        "type": "integer",
        "minimum": 0
      },
      "name": {
        "description": "The name of an item",
        "type": "string",
        "pattern": "\\S+"
      },
      "variations" : {
        "type" : "array",
        "items": {
          "type" : "object",
          "properties": {
            "metadata":{
              "type":"integer",
              "minimum": 0
            },
            "displayName":{
              "type":"string"
            }
          },
          "required": ["metadata", "displayName"],
          "additionalProperties": true
        }
      }
    },
    "required": ["id", "displayName", "stackSize", "name"],
    "additionalProperties": true
  }
}
